/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { CreateUserMetadataRequest, MapString, UpdateUserMetadataRequest, UserMetadata } from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "ui-metadata";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description Create user metadata
   *
   * @name CreateUserMetadata
   * @request POST:/v1/tenant/{tenantId}/user/{userId}/create
   * @secure
   */
  createUserMetadata = (
    tenantId: string,
    userId: string,
    data: CreateUserMetadataRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/create`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for createUserMetadata */
  createUserMetadataPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/create`);

  /**
   * @description Update user metadata
   *
   * @name UpdateUserMetadata
   * @request POST:/v1/tenant/{tenantId}/user/{userId}/update
   * @secure
   */
  updateUserMetadata = (
    tenantId: string,
    userId: string,
    data: UpdateUserMetadataRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/update`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for updateUserMetadata */
  updateUserMetadataPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/update`);

  /**
   * @description Get user metadata
   *
   * @name GetUserMetadata
   * @request GET:/v1/tenant/{tenantId}/user/{userId}
   * @secure
   */
  getUserMetadata = (
    tenantId: string,
    userId: string,
    query: {
      /** @minLength 1 */
      key: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      UserMetadata,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getUserMetadata */
  getUserMetadataPathGetter = (
    tenantId: string,
    userId: string,
    query: {
      /** @minLength 1 */
      key: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}`, query);

  /**
   * @description Delete user metadata
   *
   * @name DeleteUserMetadata
   * @request DELETE:/v1/tenant/{tenantId}/user/{userId}
   * @secure
   */
  deleteUserMetadata = (
    tenantId: string,
    userId: string,
    query: {
      /** @minLength 1 */
      key: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteUserMetadata */
  deleteUserMetadataPathGetter = (
    tenantId: string,
    userId: string,
    query: {
      /** @minLength 1 */
      key: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}`, query);
}
